import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconHourglass({
  color = "#5A6072",
  size,
}: IIconProps): ReactElement {
  return (
    <svg
      height={size || 16}
      width={size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.56174 5.84822C8.76109 6.84903 7.23892 6.84903 6.43827 5.84822L5.60957 4.81235C5.4895 4.66226 5.46609 4.45664 5.54935 4.2834C5.63261 4.11017 5.8078 4 6 4H10C10.1922 4 10.3674 4.11017 10.4507 4.2834C10.5339 4.45664 10.5105 4.66226 10.3904 4.81235L9.56174 5.84822Z"
        fill={color}
      />
      <path
        d="M6.435 10.7234C7.42024 10.2309 8.57986 10.2309 9.5651 10.7234L10.2236 11.0526C10.431 11.1563 10.5399 11.389 10.4867 11.6147C10.4334 11.8404 10.2319 11.9998 10 11.9998H6.00005C5.76815 11.9998 5.56669 11.8404 5.51342 11.6147C5.46015 11.389 5.56905 11.1563 5.77647 11.0526L6.435 10.7234Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 1.25C1.58579 1.25 1.25 1.58579 1.25 2C1.25 2.41421 1.58579 2.75 2 2.75H2.25V4.1459C2.25 5.56629 3.05251 6.86478 4.32295 7.5L4.87574 7.77639C5.06 7.86852 5.06 8.13148 4.87574 8.22361L4.32295 8.5C3.05251 9.13522 2.25 10.4337 2.25 11.8541V13.25H2C1.58579 13.25 1.25 13.5858 1.25 14C1.25 14.4142 1.58579 14.75 2 14.75H14C14.4142 14.75 14.75 14.4142 14.75 14C14.75 13.5858 14.4142 13.25 14 13.25H13.75V11.8541C13.75 10.4337 12.9475 9.13522 11.6771 8.5L11.1243 8.22361C10.94 8.13148 10.94 7.86852 11.1243 7.77639L11.6771 7.5C12.9475 6.86478 13.75 5.56629 13.75 4.1459V2.75H14C14.4142 2.75 14.75 2.41421 14.75 2C14.75 1.58579 14.4142 1.25 14 1.25H2ZM12.25 2.75H3.75V4.1459C3.75 4.99814 4.23151 5.77723 4.99377 6.15836L5.54656 6.43475C6.83639 7.07967 6.83639 8.92033 5.54656 9.56525L4.99377 9.84164C4.2315 10.2228 3.75 11.0019 3.75 11.8541V13.25H12.25V11.8541C12.25 11.0019 11.7685 10.2228 11.0062 9.84164L10.4534 9.56525C9.16361 8.92033 9.16361 7.07967 10.4534 6.43475L11.0062 6.15836C11.7685 5.77723 12.25 4.99814 12.25 4.1459V2.75Z"
        fill={color}
      />
    </svg>
  );
}
